import { useState } from "react";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";

import { Announcements } from "../../Announcements";
import { Home } from "../../Home";
import Abertos from "../Boletos";
import Certificados from "../Certificados";
import DadosCad from "../DadosCad";
import Entregas from "../Entregas";
import Header from "../Header";
import Baixados from "../Notas";
import Equipamentos from "../PastasMKT";
import Ticket from "../Tickets";
import Treinamentos from "../Treinamentos";

export default function PageContent({
  pagina,
  isPuxando,
  isPuxandoPed,
  isPuxandoEq,
  isPuxandoCad,
  dadosTitulo,
  dadosPedidos,
  dadosEquip,
  dadosCad,
  nome,
  user,
  abaTit,
  abaPed,
  handleAbaTit,
  setPagina,
}) {
  const [deliverySelected, setDeliverySelected] = useState(null);

  if (pagina === 1) {
    return isPuxando === 1 ? (
      <>
        <Header setPage={setPagina} />
        <TabContext value={abaTit}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleAbaTit}>
              <Tab label="Boletos em aberto" value="1" />
              <Tab label="Notas Fiscais" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0, mt: 1 }}>
            <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
              <Abertos dados={dadosTitulo} />
            </Paper>
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0, mt: 1 }}>
            <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
              <Baixados dados={dadosTitulo} />
            </Paper>
          </TabPanel>
        </TabContext>
      </>
    ) : (
      <LinearProgress />
    );
  }

  if (pagina === 2) {
    return isPuxandoPed === 1 ? (
      <TabContext value={abaPed}>
        <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
          <Entregas
            dados={dadosPedidos}
            deliverySelected={deliverySelected}
            setDeliverySelected={setDeliverySelected}
          />
        </Paper>
      </TabContext>
    ) : (
      <LinearProgress />
    );
  }

  if (pagina === 3) {
    return isPuxandoEq === 1 ? (
      <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
        <Equipamentos dados={dadosEquip} />
      </Paper>
    ) : (
      <LinearProgress />
    );
  }

  if (pagina === 4) {
    return isPuxandoCad === 1 ? (
      <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
        <DadosCad dados={dadosCad} nome={nome} cnpj={user} />
      </Paper>
    ) : (
      <LinearProgress />
    );
  }

  if (pagina === 5) {
    return <Treinamentos />;
  }
  if (pagina === 6) {
    return <Ticket />;
  }

  if (pagina === 7) {
    return <Certificados />;
  }

  if (pagina === 8) {
    return (
      <Home
        setPage={setPagina}
        splits={dadosTitulo}
        orders={dadosPedidos}
        setDeliverySelected={setDeliverySelected}
      />
    );
  }

  if (pagina === 9) {
    return <Announcements />;
  }

  return null;
}
